export const APP_PREFIX = 'lann-landing';
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL;